<template>
  <div v-if="!enableAnalytics" class="wrapper">
    <a target="_blank" :href="debugURL"
      ><button class="interactive">Analytics Disabled</button></a
    >
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { inject } from "./debugContext";

export default defineComponent({
  name: "DebugWrapper",
  props: {
    debugURL: {
      type: String,
      required: true
    }
  },
  setup() {
    const debugContext = inject();
    return {
      enableAnalytics: debugContext?.enableAnalytics
    };
  }
});
</script>

<style scoped>
.wrapper {
  position: absolute;
  z-index: 1;
  bottom: 5px;
  left: 5px;
}

.interactive {
  border: none;
  background: #f03c3c;
  color: white;
  opacity: 0.9;
  padding: 5px 10px;
  border-radius: 5px;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.interactive:hover {
  opacity: 1;
  transform: scale(1.1);
}
.interactive:active {
  transform: scale(1.05);
}
</style>
